import { buildApiUrl } from "../../services/apiConfig";

class processTrackerService {
  constructor() {
    this.API_HOST = process.env.REACT_APP_API_URL || 'localhost';
    this.baseUrl = buildApiUrl('PROCESS_TRACKER');
  }

  async fetchServices(selectedGroup = 'all', searchTerm = '') {
    try {
        const endpoint = selectedGroup === 'all'
            ? `${this.baseUrl}/`
            : `${this.baseUrl}/status?group=${selectedGroup}`;
      const response = await fetch(endpoint, {
        method: 'GET',
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch services:', error);
      throw error;
    }
  }
  async fetchGroups(){
    try {
      const response = await fetch(`${this.baseUrl}/groups/`, {
        method: 'GET',
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch groups:', error);
      throw error;
    }
  }
  async fetchLogs(serviceId){
    console.log('Fetching logs for serviceId:', serviceId);
    try {
      const response = await fetch(`${this.baseUrl}/${serviceId}/logs?lines=100`, {
        method: 'GET',
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Failed to fetch logs:', error);
      throw error;
    }
  }
  async startService(serviceId){
    console.log('start for serviceId:', serviceId);
    try {
      const response = await fetch(`${this.baseUrl}/${serviceId}/start`, {
        method: 'POST',
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Failed to start service:', error);
      throw error;
    }
  }
  async stopService(serviceId){
    console.log('Stop for serviceId:', serviceId);
    try {
      const response = await fetch(`${this.baseUrl}/${serviceId}/stop`, {
        method: 'POST',
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Failed to stop service:', error);
      throw error;
    }
  }
  async restartService(serviceId){
    try {
      const response = await fetch(`${this.baseUrl}/${serviceId}/restart`, {
        method: 'POST',
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Failed to restart service:', error);
      throw error;
    }
  }
  async createService(serviceData){
    try {
      const response = await fetch(`${this.baseUrl}/api/services`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(serviceData),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Failed to create service:', error);
      throw error;
    }
  }
}

export default new processTrackerService();